import { DollarSign, Shield, TrendingUp, CheckCircle2 } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";

const Benefits = () => {
  const benefits = [
    {
      icon: DollarSign,
      title: "Ahorro de Dinero",
      points: [
        "Evita pérdida de equipos caros (refrigeradores, computadores, etc.)",
        "Reduce consumo eléctrico hasta en 30%",
        "Previene multas SEC de hasta $50 UTM"
      ],
      color: "from-green-500/30 to-green-600/10"
    },
    {
      icon: Shield,
      title: "Seguridad",
      points: [
        "Previene incendios eléctricos",
        "Protege a tus empleados y clientes",
        "Cumple normativa chilena vigente"
      ],
      color: "from-blue-500/30 to-blue-600/10"
    },
    {
      icon: TrendingUp,
      title: "Continuidad del Negocio",
      points: [
        "Evita cierres por fallas eléctricas",
        "Mantén tu negocio operativo 24/7",
        "Aumenta vida útil de equipos"
      ],
      color: "from-purple-500/30 to-purple-600/10"
    },
    {
      icon: CheckCircle2,
      title: "Certificación Legal",
      points: [
        "Cumple con normativa SEC",
        "Documentación al día para inspecciones",
        "Respaldo técnico certificado"
      ],
      color: "from-primary/30 to-accent/10"
    }
  ];

  return (
    <section id="beneficios" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-industrial-gray via-dark-section/95 to-industrial-gray">
        <div className="absolute top-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-liquid-blob opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            ¿Por qué invertir en mantenimiento eléctrico?
          </h2>
          <p className="text-lg text-white/70 text-center mb-12 max-w-2xl mx-auto">
            Los beneficios superan ampliamente la inversión
          </p>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-10 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <AnimatedSection
              key={index}
              animation="slide-up"
              delay={index * 100}
            >
              <div className="backdrop-blur-xl bg-white/10 border-2 border-white/20 rounded-3xl p-8 hover:bg-white/15 transition-all duration-300 hover:scale-105 h-full">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${benefit.color} border-2 border-white/20 flex items-center justify-center mb-6 shadow-liquid-lg`}>
                  <benefit.icon className="w-8 h-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-montserrat font-bold text-white mb-4">
                  {benefit.title}
                </h3>
                
                <ul className="space-y-3">
                  {benefit.points.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                      <span className="text-white/80">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
